module.exports = __webpack_public_path__ + "assets/img/img178.665ffbfa.png";